import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { User } from '../../models';
import { calculatePaddingBoxPath } from 'html2canvas/dist/types/render/bound-curves';

@Component({
  selector: 'app-user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.scss'],
  animations: [
    trigger('expandCollapseHeader', [
      state('expanded', style({ 'border-bottom-left-radius': 0, 'border-bottom-right-radius': 0 })),
      state('collapsed', style({ 'border-bottom-left-radius': 'inherit', 'border-bottom-right-radius': 'inherit' })),
      transition('expanded <=> collapsed', animate('200ms ease-in-out')),
    ]),
    trigger('expandCollapse', [
      state('expanded', style({ height: '*', opacity: 1, overflow: 'hidden', padding: '*' })),
      state('collapsed', style({ height: '0px', opacity: 0, overflow: 'hidden', 'padding-top': 0, 'padding-bottom': 0 })),
      transition('expanded <=> collapsed', animate('200ms ease-in-out')),
    ])
  ]
})
export class UserCardComponent implements OnInit {
  @Input() user: User;
  @Input() waitOnAction: boolean;
  @Input() noSecurityGroups: boolean;

  @Input() allowEdit = true;
  @Input() allowDelete = true;

  @Input() expanded = false;
  @Input() accordion = true;

  @Output() edit = new EventEmitter<User>();
  @Output() delete = new EventEmitter<User>();
  @Output() restore = new EventEmitter<User>();

  constructor() { }

  ngOnInit(): void {
  }

  toggleAccordion() {
    if (this.accordion) {
      this.expanded = !this.expanded;
    }
  }
}
